import React, { useState, useEffect, Fragment } from 'react';
import { Grid, Panel, Stat, GateKeeper, LazyBoi } from '@components'
import { Pool } from '@archetypes'
import styled from 'styled-components';
import  { Status } from '@app/App.Controller'

const MyStakePanel = styled(
    ({ className, address }) => (
        <GateKeeper
            controllerAssertions={[
                {
                    controller: 'account',
                    key: 'status',
                    assert: val => val === Status.READY,
                    onFail: <Panel fadeIn>Connect your wallet to view your stake</Panel>,
                },

            ]}
        >
            <Panel className={className}>
                <h4 className="title"> 
                    Your stake
                </h4>
                <Pool.MyStake
                    address={address}
                />
            </Panel>
        </GateKeeper>
    ))`
    
    >.title {
        font-size: 16px;
        margin: 0px;
        color: var(--color-label, lightblue);
    }

    `

export default MyStakePanel